function isAllNumbers(text) {
    return /^\d+$/.test(text);
}
function isDelimitedNumbers(text) {
    return /^[\d\s,.-]+$/.test(text);
}
export var checkIsTextExcluded = function (text) {
    return text.length < 3 || isAllNumbers(text) || isDelimitedNumbers(text);
};
